export default "__VITE_ASSET__DenbfsX9__"